var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-container", attrs: { id: "mainDiv" } },
    [
      _c("fa", {
        staticClass: "close-icon",
        attrs: { icon: ["far", "circle-xmark"] },
        on: {
          click: function ($event) {
            return _vm.$emit("toggleSlider")
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "slider-container" }, [
        _c(
          "div",
          { staticClass: "mileage-slider" },
          [
            _vm.sliderReady
              ? _c("vue-slider", {
                  ref: "mileageSlider",
                  staticStyle: { width: "350px" },
                  attrs: {
                    min: _vm.currentMin,
                    max: _vm.currentMax,
                    interval: _vm.currentInterval,
                    marks: _vm.currentMarkers,
                    tooltip: "none",
                  },
                  on: {
                    "drag-end": function ($event) {
                      return _vm.$emit("calculateMileage", _vm.sliderValue)
                    },
                  },
                  model: {
                    value: _vm.sliderValue,
                    callback: function ($$v) {
                      _vm.sliderValue = $$v
                    },
                    expression: "sliderValue",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "mileage-details", attrs: { "no-gutters": "" } },
              [
                _c("p", [
                  _vm._v("Radius: "),
                  _c("b", [
                    _vm._v(
                      _vm._s(_vm.sliderValue) +
                        _vm._s(_vm.kmToggle ? "km" : "mi")
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("toggle-button", {
                  staticClass: "toggle",
                  attrs: {
                    sync: true,
                    labels: { checked: "km", unchecked: "mi" },
                    width: 50,
                    height: 22,
                    color: { checked: "#0496e9", unchecked: "lightgray" },
                  },
                  on: { change: _vm.toggleUnits },
                  model: {
                    value: _vm.kmToggle,
                    callback: function ($$v) {
                      _vm.kmToggle = $$v
                    },
                    expression: "kmToggle",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }